import React from 'react'
import { HiOutlineMail } from 'react-icons/hi'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4 md:pt-[120px] lg:pt-[120px] my-sm-p'>
      <form method='POST' action="https://getform.io/f/54952ac8-13f8-4692-98d5-7fc4b0d4fcde" className='flex flex-col max-w-[600px] w-full'>
        <div className='pb-8'>
            <p className='text-4xl font-bold inline border-b-4 border-[#ff914d] text-gray-300'>Contact</p>
            <p className='text-gray-300 py-4 '>Submit the form below or send me a mail <span className='inline-block ml-1 pl-1 pr-1 text-black bg-gray-400 font-bold rounded-md'>
            <HiOutlineMail className='inline-block'/> 
            rifadhrfd@gmail.com
        </span></p>
        </div>
        <input className='bg-[#ccd6f6] p-2 placeholder-gray-600 rounded-md' type="text" placeholder='Name' name='name' />
            <input className='my-4 p-2 bg-[#ccd6f6] placeholder-gray-600 rounded-md' type="email" placeholder='E-mail' name='email' />
            <textarea className='bg-[#ccd6f6] p-2 placeholder-gray-600 rounded-md' name="message" rows="10" placeholder='Message'></textarea>
            <button className='text-white border-2 hover:bg-[#ff914d] hover:border-[#ff914d] px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</button>
        </form>
    </div>
  )
}

export default Contact
